import React from "react";

const Line = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="60"
    viewBox="0 0 19 60"
  >
    <g transform="translate(-184 -333)">
      <text
        transform="translate(184 388)"
        fill="#6352e8"
        fontSize="14"
        fontFamily="Poppins-Bold, Poppins"
        fontWeight="700"
      >
        <tspan x="0" y="0">
          VS
        </tspan>
      </text>
      <path
        d="M.5,40h-1V0h1Z"
        transform="translate(193.5 333)"
        fill="#6352e8"
      />
      <path d="M8,.5H0v-1H8Z" transform="translate(189.5 373)" fill="#6352e8" />
    </g>
  </svg>
);

export default Line;
